import { render } from "./NewGameButton.vue?vue&type=template&id=76b9ebca"
import script from "./NewGameButton.vue?vue&type=script&lang=js"
export * from "./NewGameButton.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./NewGameButton.vue?vue&type=style&index=0&id=76b9ebca&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script